export const RetakeIcon = ({ color }: { color?: string }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.95938 10.9994C1.95938 6.46274 5.49508 1.95938 10.9994 1.95938C15.4447 1.95938 17.6418 5.24965 18.5781 6.99941H15.7994C15.3577 6.99941 14.9994 7.35759 14.9994 7.79941C14.9994 8.24124 15.3577 8.59941 15.7994 8.59941H20.5994C21.0412 8.59941 21.3994 8.24124 21.3994 7.79941V2.99941C21.3994 2.55759 21.0412 2.19941 20.5994 2.19941C20.1577 2.19941 19.7994 2.55759 19.7994 2.99941V5.9005C18.6722 3.91343 16.0649 0.359375 10.9994 0.359375C4.49887 0.359375 0.359375 5.69601 0.359375 10.9994C0.359375 16.3028 4.49887 21.6394 10.9994 21.6394C14.1095 21.6394 16.6989 20.4087 18.5426 18.5329C19.5298 17.5284 20.3007 16.3418 20.8263 15.0645C20.9945 14.656 20.7996 14.1885 20.3911 14.0203C19.9825 13.8521 19.5149 14.0471 19.3468 14.4556C18.8975 15.5474 18.2396 16.5586 17.4015 17.4113C15.8466 18.9935 13.6635 20.0394 10.9994 20.0394C5.49508 20.0394 1.95938 15.5361 1.95938 10.9994Z"
      fill={color}
    />
  </svg>
);
